export default __webpack_public_path__ + "static/media/blaspheme.c3c5c4cd.jpg";